import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { LanguageSelector } from './LanguageSelector';
import { OpeningCurtain } from './OpeningCurtain';
interface LanguageGateProps {
  children: React.ReactNode;
}
type GateState = 'initial-select' | 'initial-animating' | 'ready' | 'changing-language';
export function LanguageGate({
  children
}: LanguageGateProps) {
  const {
    hasSelectedLanguage,
    pendingLanguage,
    confirmLanguageChange
  } = useLanguage();
  const [gateState, setGateState] = useState<GateState>('initial-select');
  // Handle initial selection complete
  const handleInitialSelectionComplete = () => {
    setGateState('initial-animating');
  };
  // Handle initial animation complete
  const handleInitialAnimationComplete = () => {
    setGateState('ready');
  };
  // Handle navbar language switch request
  useEffect(() => {
    if (pendingLanguage && gateState === 'ready') {
      setGateState('changing-language');
    }
  }, [pendingLanguage, gateState]);
  // Handle change animation complete
  const handleChangeAnimationComplete = () => {
    confirmLanguageChange(); // Actually update the context language
    setGateState('ready');
  };
  return <>
      <AnimatePresence mode="wait" data-id="element-66">
        {gateState === 'initial-select' && <LanguageSelector key="selector" onComplete={handleInitialSelectionComplete} data-id="element-67" />}

        {gateState === 'initial-animating' && <OpeningCurtain key="initial-curtain" onComplete={handleInitialAnimationComplete} data-id="element-68" />}

        {gateState === 'changing-language' && <OpeningCurtain key="change-curtain" onComplete={handleChangeAnimationComplete} data-id="element-69" />}
      </AnimatePresence>

      {/* Main Content - Only visible when ready or changing (so it doesn't flash on initial load) */}
      <div className={`transition-opacity duration-500 ${gateState === 'ready' || gateState === 'changing-language' ? 'opacity-100' : 'opacity-0 pointer-events-none h-0 overflow-hidden'}`} data-id="element-70">
        {children}
      </div>
    </>;
}